import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class RefreshService {
  refresh$ = new Subject<number | string | 'ALL_ROWS'>();
  recomputeDynamicWidth$ = new Subject<string>();
  updateWidthForColumn$ = new Subject<{
    columnDef: string;
    updatedWidth: number;
  }>();
}
